import React from 'react';
import { StyledTableOfContents, StyledTableOfContentsListItem } from './TableOfContents.style';
import { SideBarCard } from '..'
import { useActiveHash } from '../../hooks/useActiveHash';
import { useSetRecoilState } from 'recoil';
import { isSideMenuOpenState } from '../../atoms';

const TableOfContents = (props) => {
  const { headings } = props;
  const { activeHash, setActiveHash } = useActiveHash(headings.filter((heading) => {
    if(heading.depth > 1) return true
    return false;
  }).map((heading) => slugify(heading.value)));

  const setIsSideMenuOpen = useSetRecoilState(isSideMenuOpenState);

  const onItemClicked = () => {
    setIsSideMenuOpen(false);
  };

  return (
    <SideBarCard>
      <h5>Content</h5>
      <StyledTableOfContents>
        <nav className="toc">
          <ul>
            <StyledTableOfContentsListItem className={`${!activeHash ? 'active': ''}`}><a href={`#introduction`}>Introduction</a></StyledTableOfContentsListItem>
            {headings.map((heading, index) => (
              heading.depth > 1 && heading.depth < 4 &&
              <StyledTableOfContentsListItem onClick={onItemClicked} key={index} className={`depth-${heading.depth} ${slugify(heading.value) === activeHash ? 'active': ''}`} depth={heading.depth}>
                <a href={`#${slugify(heading.value)}`}>{heading.value.trim()}</a>
              </StyledTableOfContentsListItem>
            ))}
          </ul>
        </nav>
      </StyledTableOfContents>
    </SideBarCard>
  );
};

function slugify(text) {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-");
}

export default TableOfContents;
